import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Input } from 'reactstrap';
import validator from 'validator';

import MobileNav from '@components/Quoting/MobileNav/MobileNav';
import TextBox from '@components/TextBox/TextBox';
import Css from './Passenger.scss';

import LegRow from './LegRow/LegRow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as actions from '@store/actions';

const required = value => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'Please fill out this field.';
  }
};
const weight = value => {
  if (!validator.isInt(value, { min: 1 })) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'Value must be greater then 0.';
  }
};
const animalWeight = value => {
  if (!validator.isInt(value, { min: 1, max: 400 })) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'Value must be beetwen 1 and 400.';
  }
};
const luggageWeight = value => {
  const aircraft = localStorage.getItem('selectedAircraft');
  if (aircraft === 'E50P' && !validator.isInt(value, { min: 1, max: 250 })) {
    return 'Value must be beetwen 0 and 250.';
  }
  if (aircraft !== 'E50P' && !validator.isInt(value, { min: 1, max: 325 })) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'Value must be beetwen 0 and 325.';
  }
};

const date = value => {
  if (
    value.match(
      /^[0-1]{1,1}[0-9]{1,1}\/[0-3]{1,1}[0-9]{1,1}\/[1-2]{1,1}[0-9]{3,3}$/
    ) === null
  ) {
    return 'Required date format: MM/DD/YYYY.';
  }
};

const fieldValidator = {
  firstName: [required],
  lastName: [required],
  weight: [required, weight],
  dob: [required, date],
  totalLuggageWeight: [required, luggageWeight],
  dogWeight1: [required, animalWeight],
  dogWeight2: [required, animalWeight],
  catWeight1: [required, animalWeight],
  catWeight2: [required, animalWeight]
};
const defaultPassenger = {
  firstName: {
    value: '',
    visited: true,
    error: false
  },
  lastName: {
    value: '',
    visited: false,
    error: false
  },
  weight: {
    value: '',
    visited: false,
    error: false
  },

  dob: {
    value: '',
    visited: false,
    error: false
  }
};
const defaultFormFields = {
  totalLuggageWeight: {
    value: '',
    visited: false,
    error: false
  },
  animalWeight: {
    value: '',
    visited: false,
    error: false
  }
};

class Passenger extends Component {
  constructor(props) {
    super(props);

    const defaultState = [];
    const authData = localStorage.getItem('passengers');
    let localLegs = [];
    if (authData) {
      localLegs = JSON.parse(authData);
    }

    let legIndex = 0;
    for (let i = 1; i <= props.legAmount; i++) {
      legIndex = localLegs.findIndex(l => {
        return l.legNo === i;
      });

      if (legIndex > -1) {
        defaultState.push(localLegs[legIndex]);
      } else {
        defaultState.push({
          legNo: i,
          passangerNo: 1,
          dogsNo: 0,
          dogWeight1: JSON.parse(
            JSON.stringify(defaultFormFields.animalWeight)
          ),
          dogWeight2: JSON.parse(
            JSON.stringify(defaultFormFields.animalWeight)
          ),
          catsNo: 0,
          catWeight1: JSON.parse(
            JSON.stringify(defaultFormFields.animalWeight)
          ),
          catWeight2: JSON.parse(
            JSON.stringify(defaultFormFields.animalWeight)
          ),
          totalLuggageWeight: JSON.parse(
            JSON.stringify(defaultFormFields.totalLuggageWeight)
          ),
          passengers: [JSON.parse(JSON.stringify(defaultPassenger))]
        });
      }
    }

    this.state = { legData: defaultState };
  }

  onPassengerNoChange = (legNo, value) => {
    const legData = [...this.state.legData];
    const legIndex = legData.findIndex(l => {
      return l.legNo === legNo;
    });

    legData[legIndex].passangerNo = value * 1;

    const passengers = [];
    for (let i = 0; i < value; i++) {
      passengers.push(
        legData[legIndex].passengers[i] !== undefined
          ? JSON.parse(JSON.stringify(legData[legIndex].passengers[i]))
          : JSON.parse(JSON.stringify(defaultPassenger))
      );
    }

    legData[legIndex].passengers = passengers;

    this.setState({
      legData: legData
    });
  };

  onDropdownChange = (legNo, name, value) => {
    const legData = [...this.state.legData];
    const legIndex = legData.findIndex(l => {
      return l.legNo === legNo;
    });

    legData[legIndex][name] = parseInt(value, 10);

    this.setState({
      legData: legData
    });
  };

  onInputChange = (legNo, name, value) => {
    const legData = [...this.state.legData];
    const legIndex = legData.findIndex(l => {
      return l.legNo === legNo;
    });

    legData[legIndex][name].value = value;
    legData[legIndex][name].error = false;
    legData[legIndex][name].visited = true;

    for (let i = 0; i < fieldValidator[name].length; i++) {
      legData[legIndex][name].visited = true;
      const validationMsg = fieldValidator[name][i](value);
      if (validationMsg !== undefined) {
        legData[legIndex][name].error = validationMsg;
      }
    }

    this.setState({
      legData: legData
    });
  };

  onPassengerInputChange = (legNo, index, name, value) => {
    const legData = [...this.state.legData];
    const legIndex = legData.findIndex(l => {
      return l.legNo === legNo;
    });

    if (name === 'firstName' || name === 'lastName') {
      value = value.substring(0, 50);
    }

    legData[legIndex].passengers[index][name].value = value;
    legData[legIndex].passengers[index][name].error = false;
    legData[legIndex].passengers[index][name].visited = true;
    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](value);
      if (validationMsg !== undefined) {
        legData[legIndex].passengers[index][name].error = validationMsg;
      }
    }

    const aircraft = localStorage.getItem('selectedAircraft');
    if (
      ((aircraft === 'E50P' && index === 4) || index === 7) &&
      name === 'dob'
    ) {
      const toCheck = new Date(value);
      const now = new Date(
        this.props.flightInfo['525B'].legs[legIndex].departure_datetime
      );
      now.setFullYear(now.getFullYear() - 2);
      if (toCheck < now) {
        legData[legIndex].passengers[index][name].error =
          'Infant only - must be under the age of 2';
      }
    }

    this.setState({
      legData: legData
    });
  };

  copyPriorLeg = legNo => {
    const legData = [...this.state.legData];

    let legIndex = legData.findIndex(l => {
      return l.legNo === legNo;
    });
    const legUpdateNo = legData[legIndex].legNo;
    const legInfo = JSON.parse(JSON.stringify(legData[legIndex - 1]));
    legData[legIndex] = {
      ...legInfo,
      legNo: legUpdateNo
    };
    console.log(legData);

    this.setState({
      legData: [...legData]
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const legData = JSON.parse(JSON.stringify(this.state.legData));
    let isValid = true;

    for (let i = 0; i < legData.length; i++) {
      for (let j = 0; j < legData[i].passengers.length; j++) {
        for (let index in legData[i].passengers[j]) {
          let objectToValid = legData[i].passengers[j][index];
          objectToValid.visited = true;
          for (let k = 0; k < fieldValidator[index].length; k++) {
            const validationMsg = fieldValidator[index][k](objectToValid.value);
            if (validationMsg !== undefined) {
              objectToValid.error = validationMsg;
              isValid = false;
            }
          }
        }
      }

      for (let j = 0; j < fieldValidator['totalLuggageWeight'].length; j++) {
        legData[i].totalLuggageWeight.visited = true;
        const validationMsg = fieldValidator.totalLuggageWeight[j](
          legData[i].totalLuggageWeight.value
        );
        if (validationMsg !== undefined) {
          legData[i].totalLuggageWeight.error = validationMsg;
          isValid = false;
        }
      }

      // Animal validation
      for (let dogsNo = 1; dogsNo <= legData[i].dogsNo; dogsNo++) {
        let objectToValid = legData[i]['dogWeight' + dogsNo];
        objectToValid.visited = true;
        for (let k = 0; k < fieldValidator['dogWeight' + dogsNo].length; k++) {
          const validationMsg = fieldValidator['dogWeight' + dogsNo][k](
            objectToValid.value
          );
          if (validationMsg !== undefined) {
            objectToValid.error = validationMsg;
            isValid = false;
          }
        }
      }
      for (let catsNo = 1; catsNo <= legData[i].catsNo; catsNo++) {
        let objectToValid = legData[i]['catWeight' + catsNo];
        objectToValid.visited = true;
        for (let k = 0; k < fieldValidator['catWeight' + catsNo].length; k++) {
          const validationMsg = fieldValidator['catWeight' + catsNo][k](
            objectToValid.value
          );
          if (validationMsg !== undefined) {
            objectToValid.error = validationMsg;
            isValid = false;
          }
        }
      }
    }

    this.setState({
      legData: legData
    });

    if (isValid) {
      this.props.onSubmit(legData);
      this.props.nextClick();
    }
  };

  render = () => {
    const {
      isMobile,
      user,
      userEmail,
      legAmount,
      contractVersion
    } = this.props;

    const legs = [];
    for (let i = 1; i <= legAmount; i++) {
      const legData = this.state.legData.find(x => x.legNo === i);
      legs.push(
        <LegRow
          key={`leg-${i}`}
          isMobile={isMobile}
          contractVersion={contractVersion}
          legNo={i}
          {...legData}
          onDropdownChange={(name, value) =>
            this.onDropdownChange(i, name, value)
          }
          onInputChange={(name, value) => this.onInputChange(i, name, value)}
          onPassengerInputChange={(index, name, value) =>
            this.onPassengerInputChange(i, index, name, value)
          }
          onPassengerNoChange={value => this.onPassengerNoChange(i, value)}
          copyPriorLeg={() => this.copyPriorLeg(legData.legNo)}
        />
      );
    }

    const nextButton = (
      <button
        onClick={event => this.handleSubmit(event)}
        className={'btn btn-transparent pl-3'}
      >
        <FontAwesomeIcon icon={['fas', 'chevron-right']} />
      </button>
    );

    return (
      <React.Fragment>
        {isMobile && (
          <MobileNav
            {...this.props}
            title={'Passenger'}
            rightButton={nextButton}
          />
        )}

        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.handleSubmit.bind(this)}
        >
          <TextBox header={!isMobile ? 'Passenger' : false}>
            <div
              className={
                isMobile
                  ? 'background-white p-4 ' + Css['member-content']
                  : 'background-white p-4'
              }
            >
              {contractVersion === 2 ? (
                <React.Fragment>
                  <Row>
                    <Col>
                      <Input
                        defaultValue={this.props.accountName}
                        readOnly={true}
                      />
                    </Col>
                    <Col>
                      <Input
                        defaultValue={this.props.contactEmail}
                        readOnly={true}
                      />
                    </Col>
                  </Row>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Row className={'mb-3'}>
                    <Col>
                      <Input defaultValue={user.FirstName} readOnly={true} />
                    </Col>
                    <Col>
                      <Input defaultValue={user.LastName} readOnly={true} />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Input defaultValue={user.HomePhone} readOnly={true} />
                    </Col>
                    <Col>
                      <Input defaultValue={userEmail} readOnly={true} />
                    </Col>
                  </Row>
                </React.Fragment>
              )}
            </div>
            {legs}
          </TextBox>
          {!isMobile && (
            <button
              className="btn btn-transparent mt-2 float-left"
              onClick={this.props.prevClick}
            >
              <strong>
                <FontAwesomeIcon icon={['fas', 'chevron-left']} />
                &nbsp;&nbsp;Back
              </strong>
            </button>
          )}
          <button
            className={
              'btn ' +
              (isMobile
                ? 'd-block mx-auto btn-fullred'
                : 'float-right btn-transparent mt-2')
            }
          >
            <strong>
              Next&nbsp;&nbsp;
              <FontAwesomeIcon icon={['fas', 'chevron-right']} />
            </strong>
          </button>
        </form>
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => {
  return {
    user: state.auth.data,
    userEmail: state.auth.mail,
    legAmount: state.flightInfo.data.legs_amount,
    flightInfo: state.flightInfo.data,
    contractVersion: state.auth.data.profile_ContractVersion,
    accountName: state.flightInfo.accountName,
    contactEmail: state.flightInfo.contactEmail
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: passengers => dispatch(actions.quotingSetPassengers(passengers))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Passenger);



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/Passenger/Passenger.jsx